module.exports = __webpack_public_path__ + "static/media/edit.0bd62c19.svg";